import { render, staticRenderFns } from "./TractTypeForm.vue?vue&type=template&id=7b325cca&"
import script from "./TractTypeForm.vue?vue&type=script&lang=js&"
export * from "./TractTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports